<template>
  <SettingsPageFull>
    <template #title>
      <div class="flex space-x-3">
        <font-awesome-icon :icon="['fal', 'landmark']" size="2x" />
        <span class="text-2xl font-bold capitalize-first">
          {{ $t('navigation.content_company_title') }}
        </span>
      </div>
    </template>

    <template #cta>
      <BaseButton
        color="primary"
        :title="$t('button.add_new_f', { var: $t('global.company') })"
        icon="plus"
        @click="this.$router.push({ name: 'settings_create_company_route' })"
        v-if="$can('manage_content')"
      />
    </template>

    <template #body>
      <CompanyCardComponent
        v-for="company in companies"
        :company="company"
        :key="company.id"
        @click="
          this.$router.push({
            name: 'settings_edit_company_route',
            params: { id: company.id }
          })
        "
      />
    </template>
  </SettingsPageFull>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import CompanyCardComponent from './components/CompanyCardComponent'

export default {
  name: 'TheCompanyIndexPage',
  components: {
    CompanyCardComponent
  },
  computed: {
    ...mapGetters({ companies: 'company/getCompaniesList' })
  },
  methods: {
    // ...mapActions(['', '', '']),
    ...mapActions({
      fetchCompanyIndex: 'company/fetchCompanyIndex',
      deleteCompanyById: 'company/deleteCompanyById',
      undoDeleteCompanyById: 'company/undoDeleteCompanyById'
    }),
    deleteCompany(id) {
      this.deleteCompanyById({
        id: id
      }).then(() => {
        this.$h.toastAction(
          'delete',
          this.$t('toasts.deleted_f', { var: this.$t('attributes.company') }),
          null,
          [
            {
              title: this.$t('button.cancel'),
              class: 'text-red-700',
              action: () => this.undoDeleteCompany(id)
            }
          ]
        )
      })
    },
    undoDeleteCompany(id) {
      this.undoDeleteCompanyById({
        id: id
      }).then(() => {
        this.$h.toastSuccess(
          this.$t('toasts.reseted_f', { var: this.$t('attributes.company') })
        )
      })
    }
  },
  async mounted() {
    await this.fetchCompanyIndex()
  }
}
</script>
